/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_1_1Inputs */

const en_gc_search_guides_gridcraft_online_sections_3_table_rows_1_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_1_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check the connection and try again. If the error panel offers Open with WebGL, use that fallback.`)
};

const zh_gc_search_guides_gridcraft_online_sections_3_table_rows_1_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_1_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检查网络后重试。如果错误面板显示 Open with WebGL，可以使用该备用入口。`)
};

/**
* | output |
* | --- |
* | "Check the connection and try again. If the error panel offers Open with WebGL, use that fallback." |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_1_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_3_table_rows_1_1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_1_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_1_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_3_table_rows_1_1(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_3_table_rows_1_1(inputs)
});
export { gc_search_guides_gridcraft_online_sections_3_table_rows_1_1 as "gc.search_guides.gridcraft_online.sections.3.table.rows.1.1" }